import React, { useState, useEffect, useRef } from "react";
import {AddIcon, DeleteIcon} from "../../assets/icons/Icons";

const FormRepeater = ({columns,  maxRows = 5, RenderComponent , onRowChange, rowData = [], ...props}) => {
    const generateId = () => Math.floor(Math.random() * 100000); // 0–99999

    const [rows, setRows] = useState([{
        rowId: generateId()
    }]);

    // Row writes can arrive from a debounced callback that captured an earlier
    // render. Building from a ref rather than from the closure keeps such a
    // write from reverting a field set in the meantime, which is how a card's
    // validated type used to disappear when the amount debounce landed after it.
    const rowsRef = useRef(rows);
    const commitRows = (updatedRows, notify = true) => {
        rowsRef.current = updatedRows;
        setRows(updatedRows);
        if (notify && onRowChange) {
            onRowChange(updatedRows);
        }
    };

    const addRow = () => {
        const current = rowsRef.current;
        if (current.length < maxRows) {
            const newRow = {
                rowId: generateId()
            };
            if(current[current.length - 1]?.load_amount){
                newRow.load_amount = current[current.length - 1]?.load_amount;
            }
            // An empty row is not reported upward: it carries nothing to validate.
            commitRows([...current, newRow], false);
        }
    };

    const removeRow = (index) => {
        commitRows(rowsRef.current.filter((_, i) => i !== index));
    };

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...rowsRef.current];
        if (typeof field === 'object') {
            updatedRows[index] = { ...updatedRows[index], ...field };
        } else {
            updatedRows[index] = { ...updatedRows[index], [field]: value };
        }
        commitRows(updatedRows);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Spreči default submit ponašanje
            addRow();
        }
    };

    useEffect(() => {
        if (rowData.length > 0 && JSON.stringify(rowData) !== JSON.stringify(rowsRef.current)) {
            rowsRef.current = rowData;
            setRows(rowData);
        }
    }, [rowData]);

    return (
        <div className={`row ${props.className}`}>
            <table className="table-no-borders table-align-baseline">
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index}>{col}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => {
                        return (
                            <tr key={row.rowId} onKeyDown={handleKeyDown}>
                                {RenderComponent && (
                                    <RenderComponent
                                        rowIndex={index}
                                        rowData={row}
                                        onFieldChange={(field, value) =>
                                            handleRowChange(index, field, value)
                                        }
                                        removeRow={() => removeRow(index)}
                                        {...props}
                                    />
                                )}
                            </tr>
                        );
                    })}
                </tbody>
                {rows.length < maxRows && !props.hideAddRow && (
                    <tfoot>
                        <tr>
                            <td>
                                <button onClick={addRow} className="btn btn-with-icon-left btn-medium btn-transparent">
                                    <AddIcon/>
                                    {props.addRowText ?? 'Add Row'}
                                </button>
                            </td>
                        </tr>
                    </tfoot>)
                }
            </table>
        </div>
    );
};

export default FormRepeater;
